import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {CertifFournisseur} from 'src/app/domain/fournisseur/certif-fournisseur';
import {MatTableDataSource} from '@angular/material/table';
import {icons} from 'src/app/ui/icons';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {DialogRenouvelerCertifComponent} from '../../dialog-renouveler-certif/dialog-renouveler-certif.component';
import {isEmpty} from 'src/app/utils/is-empty';
import {CertifFournisseurService} from 'src/app/modules/services/fournisseur/certif-four/certif-fournisseur.service';
import {CertifAchetService} from 'src/app/modules/services/acheteur/certif/certif-achet.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {DateFormatTimePipe} from '../../../../../../modules/pipes/pipes/date-formatwithtime.pipe';

type Column = keyof CertifFournisseur | 'action';

@Component({
    selector: 'app-table-nompr-certiffour',
    templateUrl: './table-nompr-certiffour.component.html',
    styleUrls: ['./table-nompr-certiffour.component.css']
})
export class TableNomprCertiffourComponent implements OnInit {

    @Input() certif: CertifFournisseur[];
    @Input() isPublic: boolean = false;
    @Output() sort = new EventEmitter<any>();
    @Input() acheteur = false;
    @Input() bizRegNo = '';
    message = 'Les informations sur l\'utilisateur n\'existent pas.';
    displayedColumns: Column[] = [];
    dataSource = new MatTableDataSource<CertifFournisseur>();
    displayedColumnsFR: Column[] = [
        'userId',
        'staffDeptNm',
        'staffNm',
        'regDt',
        'action',


    ];

    displayedColumnsAR: Column[] = [
        'userId',
        'staffDeptNm',
        'staffNm',
        'regDt',
        'action',


    ];
    displayedColumnsEN: Column[] = [
        'userId',
        'staffDeptNm',
        'staffNm',
        'regDt',
        'action',

    ];

    labels: Partial<Record<Column, string>> = {

        userId: 'ID utilisateur',
        staffDeptNm: 'Département',
        staffNm: 'Nom et prénom',
        regDt: 'Date heure enregistrement certificat électronique',


    };
    icons = icons;
    @Input() ondelete: boolean;
    isLoading: boolean = false;

    constructor(private dialog: MatDialog,
                private toast: ToastService,
                private confirmDialogService: ConfirmDialogService,
                private apptranstlte: AppTranslateService,
                private certifFournisseurService: CertifFournisseurService,
                private certifAchetService: CertifAchetService,
                private router: Router, private appTranslateService: AppTranslateService,
                private dateFormatTimePipe: DateFormatTimePipe
    ) {
    }

    get readColumns() {
        if (this.getlang()) {
            this.displayedColumns = this.displayedColumnsAR;
        } else {
            this.displayedColumns = this.displayedColumnsFR;
        }
        return this.displayedColumns.filter(
            (column) => column !== 'action'
        );
    }

    getlang() {
        return this.apptranstlte.getDefaultLang() == 'ar';
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {certif, bizRegNo} = changes;
        if (certif?.currentValue !== certif?.previousValue) {
            this.loadDataSource(certif.currentValue);
        }
    }

    loadDataSource(certif: CertifFournisseur[]) {
        this.dataSource.data = certif;
        // this.dataSource.data.filter(function($filter) {
        //     return function(date, format) {
        //         if (date) {
        //             return new DateFormatTimePipe().transform(date);
        //         } else {
        //             return '';
        //         }
        //     };
        // });
        let tData = [...this.dataSource.data];
        for (const item of tData) {
            item['regDt'] = this.dateFormatTimePipe.transform(new Date(item.regDt));
        }
        this.dataSource.data = [...tData];
    }


    renouveler(certif) {


        const dialogRef = this.dialog.open(DialogRenouvelerCertifComponent, {
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            data: {
                acheteur: this.acheteur,
                bizRegNo: this.bizRegNo,
                userId: certif.userId
            },
            width: '75vw',
        });

        dialogRef.afterClosed().subscribe((result) => {

            if (!isEmpty(result)) {
                console.log('result.data',result.data)
                this.isLoading = true;
                if (!this.acheteur) {
                    this.certifFournisseurService.updateCertifFourni(result.data).subscribe({
                        next: res => {
                            if (res['payload'].resultMsg == 'success') {
                                if (!['DUPL', 'NOT_IN_LIST_Mand', 'Already_Exist','INVALID-CERT','EXP-CERT','DONNEES_ERRON'].includes(res['payload'].errorMsg)){
                             
                                    this.toast.success('saved_successfully');
                                    this.isLoading = false;
                                }
                               
                            } else {
                             
                                    if(res['payload'].errorMsg== 'DUPL')
                                    this.toast.error( 'Il existe un duplicatat de ce certificat.')
                                    if(res['payload'].errorMsg== 'INST_CHECKED')
                                    this.toast.error( 'Il existe un duplicat de ce certificat.')
                                        if(res['payload'].errorMsg== 'NOT_IN_LIST_Mand')
                                        this.toast.error( 'Personne inexistante dans la liste des mandataires.')
                                        if(res['payload'].errorMsg=='Already_Exist')
                                        this.toast.error( 'Personne déjà enregistrée.');
                                        if(res['payload'].errorMsg=='INVALID-CERT')
                                        this.toast.error( 'Certificat invalide.');
                                        if(res['payload'].errorMsg== 'EXP-CERT')
                                        this.toast.error('Le certificat est expiré ');
                                            if(res['payload'].errorMsg== 'DONNEES_ERRON')
                                            this.toast.error( 'Merci de vérifier vos données ');
                                             this.isLoading = false;
                                  
                                
                            }


                        }, error: (e) => {
                            this.toast.error();
                            console.error('Error in TableNomprCertiffourComponent/renouveler(), Error:: ', e);
                            this.isLoading = false;
                        }
                    });
                } else {
                    this.certifAchetService.updateCertifAcheteur(result.data).subscribe({
                        next: res => {
                            if (!['DUPL', 'NOT_IN_LIST_Mand', 'Already_Exist','INVALID-CERT','EXP-CERT','DONNEES_ERRON'].includes(res['payload'].errorMsg)){
                                this.toast.success('saved_successfully');
                                this.isLoading = false;
                            } else {
                               console.log('terst   ::  ', res['payload'].errorMsg)
                                    
                                        if(res['payload'].errorMsg== 'DUPL')
                                        this.toast.error( 'Il existe un duplicatat de ce certificat.')
                                            if(res['payload'].errorMsg== 'NOT_IN_LIST_Mand')
                                            this.toast.error( 'Personne inexistante dans la liste des mandataires.')
                                            if(res['payload'].errorMsg=='Already_Exist')
                                            this.toast.error( 'Personne déjà enregistrée.');
                                            if(res['payload'].errorMsg=='INVALID-CERT')
                                            this.toast.error( 'Certificat invalide.');
                                            if(res['payload'].errorMsg== 'EXP-CERT')
                                            this.toast.error('Le certificat est expiré ');
                                            if(res['payload'].errorMsg== 'DONNEES_ERRON')
                                            this.toast.error( 'Merci de vérifier vos données ');
          
                                    this.isLoading = false;
                                
                               
                            }


                        }, error: (e) => {
                            this.toast.error();
                            console.error('Error in TableNomprCertiffourComponent/renouveler(), Error:: ', e);
                            this.isLoading = false;
                        }
                    });
                }


            }

        });
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }


}

function newEventEmitter<T>() {
    throw new Error('Function not implemented.');
}
